import type { BadgeProps } from '@wartek-id/badge'
import { Badge } from '@wartek-id/badge'

import type { StatusPelaksanaanUnion } from 'types/kinerja-ps-pegawai'

const getBadgeProps = (
  state: StatusPelaksanaanUnion,
  isAppealInProgress?: boolean
): { text: string; variant: BadgeProps['variant'] } => {
  if (isAppealInProgress) {
    return { text: 'Perubahan sedang diajukan', variant: 'neutral' }
  }

  switch (state) {
    // Praktik Kinerja
    case 'DISKUSI_PERSIAPAN':
      return { text: 'Diskusi Persiapan', variant: 'informational' }
    case 'PENDAMPINGAN_SEKOLAH':
      return {
        text: 'Pendampingan Satuan Pendidikan',
        variant: 'informational',
      }
    case 'DISKUSI_TINDAK_LANJUT':
    case 'DISKUSI_TINDAK_LANJUT_PENILAIAN':
      return { text: 'Rencana Tindak Lanjut', variant: 'informational' }
    case 'UPAYA_TINDAK_LANJUT':
      return { text: 'Upaya Tindak Lanjut', variant: 'informational' }
    case 'REFLEKSI_TINDAK_LANJUT':
    case 'REFLEKSI_TINDAK_LANJUT_PENILAIAN':
      return {
        text: 'Refleksi dan Evaluasi Tindak Lanjut',
        variant: 'informational',
      }
    case 'SELESAI':
      return { text: 'Sudah Selesai', variant: 'success' }

    // Perilaku Kerja
    case 'MULAI_LAKSANAKAN':
      return { text: 'Laksanakan Sesuai Rencana', variant: 'informational' }
    case 'SUDAH_DINILAI':
      return { text: 'Sudah Selesai', variant: 'success' }

    // Pengembangan Kompetensi
    case 'MULAI_REFLEKSI':
      return { text: 'Isi Refleksi', variant: 'informational' }
    case 'SUDAH_REFLEKSI':
      return { text: 'Sudah Selesai', variant: 'success' }

    // Pelaksanaan Tugas
    case 'CENTANG_KETERSEDIAAN_DOKUMEN':
      return { text: 'Konfirmasi Pelaksanaan', variant: 'informational' }
    case 'DOKUMEN_TERSEDIA':
    case 'DOKUMEN_TERSEDIA_TK':
      return { text: 'Sudah Selesai', variant: 'success' }
  }
}

export function PelaksanaanStatusBadge({
  state,
  isAppealInProgress,
}: {
  state: StatusPelaksanaanUnion
  isAppealInProgress?: boolean
}) {
  const badgeProps = getBadgeProps(state, isAppealInProgress)

  if (!badgeProps) {
    // This statement should be unreachable.
    // If it's reached, it means there's a new state that's not handled.

    console.error(`Invalid pelaksanaan state: ${state}`)

    return null
  }

  return (
    <Badge variant={badgeProps.variant} className="w-fit">
      {badgeProps.text}
    </Badge>
  )
}

export default PelaksanaanStatusBadge
